/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  InputGroup,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

// Moment
import moment from "moment";

// Datepicker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import pt from "date-fns/locale/pt";

const CustomDatepicker2 = ({ t, type, onChange, values, disabled }) => {
  const [date, setDate] = useState("");
  const [day, setDay] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [isInserted, setIsInserted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (error)
      setTimeout(() => {
        setError(false);
      }, 2000);
  }, [error]);

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return (
    <React.Fragment>
      <FormGroup>
        <Row>
          <Col md="3">
            <Label id="skill-work-days-day" className="font-weight-light">
              {type === "day" ? t("Day") : t("Date")}
            </Label>
            {type === "day" ? (
              <ButtonDropdown
                isOpen={isOpen}
                toggle={() => setIsOpen(!isOpen)}
                direction="down"
                className="w-100 rounded"
              >
                <DropdownToggle
                  disabled={disabled}
                  caret
                  color="light"
                  className="customButtonDatepicker"
                >
                  {day === "" ? t("Select") : t(days[day])}
                </DropdownToggle>
                <DropdownMenu className="w-100">
                  <DropdownItem onClick={() => setDay(0)}>
                    {t("Sunday")}
                  </DropdownItem>
                  <DropdownItem onClick={() => setDay(1)}>
                    {t("Monday")}
                  </DropdownItem>
                  <DropdownItem onClick={() => setDay(2)}>
                    {t("Tuesday")}
                  </DropdownItem>
                  <DropdownItem onClick={() => setDay(3)}>
                    {t("Wednesday")}
                  </DropdownItem>
                  <DropdownItem onClick={() => setDay(4)}>
                    {t("Thursday")}
                  </DropdownItem>
                  <DropdownItem onClick={() => setDay(5)}>
                    {t("Friday")}
                  </DropdownItem>
                  <DropdownItem onClick={() => setDay(6)}>
                    {t("Saturday")}
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            ) : (
              <InputGroup>
                <DatePicker
                  autoComplete="off"
                  id="date"
                  className="form-control"
                  selected={date}
                  placeholderText={t("Select")}
                  onChange={(date) => {
                    setDate(date);
                  }}
                  dateFormat="dd/MM/yyyy"
                />
              </InputGroup>
            )}
          </Col>
          <Col md="3">
            <Label id="skill-work-days-start" className="font-weight-light">
              {t("Start")}
            </Label>
            <InputGroup>
              <DatePicker
                autoComplete="off"
                disabled={disabled}
                id="startField"
                className="form-control"
                selected={start}
                onChange={(hour) => setStart(hour)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={t("Time")}
                dateFormat="HH:mm"
              />
            </InputGroup>
          </Col>
          <Col md="3">
            <Label id="skill-work-days-end" className="font-weight-light">
              {t("End")}
            </Label>
            <InputGroup>
              <DatePicker
                autoComplete="off"
                disabled={disabled}
                id="endField"
                className="form-control"
                selected={end}
                onChange={(hour) => {
                  setEnd(hour);
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={t("Time")}
                dateFormat="HH:mm"
              />
            </InputGroup>
          </Col>
          <Col md="3" className="mt-auto">
            <Button
              disabled={disabled}
              type="button"
              color="success"
              className={"waves-effect waves-light w-100 mr-2 "}
              style={{
                cursor: !disabled ? "pointer" : "no-drop",
              }}
              onClick={() => {
                let d = date ? moment(date).format("DD/MM/YYYY") : t(days[day]);
                let s = moment(start).format("HH:mm");
                let e = moment(end).format("HH:mm");
                let objItem = date
                  ? {
                      daydate: d,
                      start: s,
                      end: e,
                    }
                  : {
                      daydate: d,
                      day: day.toString(),
                      start: s,
                      end: e,
                    };
                let aux = values && values.length > 0 ? values : [];
                setIsInserted(
                  aux.some((e) => JSON.stringify(e) === JSON.stringify(objItem))
                );
                if (
                  ((type === "day" && day !== "") ||
                    (type !== "day" && date !== "")) &&
                  start &&
                  end &&
                  new Date(end).getTime() > new Date(start).getTime() &&
                  !aux.some(
                    (e) => JSON.stringify(e) === JSON.stringify(objItem)
                  )
                ) {
                  setError(false);
                  aux.unshift(objItem);
                  type === "day" && setDay(day !== 6 ? day + 1 : 0);
                  onChange && onChange(aux);
                } else {
                  setError(true);
                }
              }}
            >
              {t("Add")}
            </Button>
          </Col>

          <Col className={error ? "text-danger text-center my-3" : "d-none"}>
            {error
              ? new Date(end).getTime() <= new Date(start).getTime()
                ? t("End time must be greater than Start Time")
                : isInserted
                ? t("Day already added")
                : t("Fill all fields")
              : null}
          </Col>
        </Row>
      </FormGroup>
      {values &&
        values.length > 0 &&
        values.map((item, idx) => (
          <Row className="d-flex" key={idx}>
            <Col md="3">
              <input
                className="form-control"
                type="text"
                value={item.daydate}
                disabled
              />
            </Col>
            <Col md="3">
              <input
                className="form-control"
                type="text"
                value={item.start}
                disabled
              />
            </Col>
            <Col md="3">
              <input
                className="form-control"
                type="text"
                value={item.end}
                disabled
              />
            </Col>
            <Col md="3" className="mt-auto mb-3">
              <Button
                type="button"
                color="danger"
                className={"waves-effect waves-light w-100 mr-2 "}
                onClick={() => {
                  let aux = values && values.length > 0 ? values : [];
                  let auxRemoved = [];
                  for (let i = 0; i < aux.length; i++) {
                    if (i !== idx) {
                      auxRemoved.push(aux[i]);
                    }
                  }
                  onChange && onChange(auxRemoved);
                }}
              >
                {t("Delete")}
              </Button>
            </Col>
          </Row>
        ))}
    </React.Fragment>
  );
};

export default withTranslation()(CustomDatepicker2);
